"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[990],{

/***/ 50410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6949);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2349);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23720);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroDescription = (param)=>{
    let { align , color ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingProps */ .tF
    } , className ="" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__description", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_5__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_4__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroDescription.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .textAlignPropTypes */ .g4,
    color: _props_sx__WEBPACK_IMPORTED_MODULE_5__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroDescription);


/***/ }),

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 72989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42866);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6949);
/* harmony import */ var _r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12985);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18981);














const Title = (param)=>/*#__PURE__*/ {
    let { className ="" , color , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
Title.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const TitleV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
TitleV2.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const DescriptionV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    }  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__description-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            fontSize: "l",
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mt: 4
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        children: children
    });
};
DescriptionV2.propTypes = {
    color: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
const Body = (param)=>/*#__PURE__*/ {
    let { children =null  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
Body.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node
};
const Action = (param)=>/*#__PURE__*/ {
    let { ActionComponent =_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        utility: {
            justify: "center"
        },
        spacing: {
            mt: 8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
            sx: {
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionComponent, {
                ...props,
                children: children
            })
        })
    });
};
Action.propTypes = {
    ActionComponent: prop_types__WEBPACK_IMPORTED_MODULE_13__.elementType,
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node.isRequired
};
const LandingSimpleSection = (param)=>{
    let { className ="" , isBorderNone =false , bgColor , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , containerProps , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section", !isBorderNone && "landing-simple-section--border-bottom", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            bgColor
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(utility))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            ...containerProps,
            children: children
        })
    });
};
LandingSimpleSection.propTypes = {
    bgColor: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool,
    containerProps: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.shape)({
        sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        md: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        center: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool
    }),
    ..._Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const SectionLabel = (param)=>{
    let { utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__label", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
SectionLabel.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
LandingSimpleSection.Label = SectionLabel;
LandingSimpleSection.Title = Title;
LandingSimpleSection.TitleV2 = TitleV2;
LandingSimpleSection.DescriptionV2 = DescriptionV2;
LandingSimpleSection.Body = Body;
LandingSimpleSection.Action = Action;
/* harmony default export */ __webpack_exports__["Z"] = (LandingSimpleSection);


/***/ }),

/***/ 15945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Line_Line; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/Line.js






const Line = (param)=>{
    let { className ="" , opacity ="" , isGradient =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    }  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("line", opacity && "line--opacity-".concat(opacity), isGradient && "line--gradient", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className)
    });
};
Line.propTypes = {
    className: prop_types.string,
    opacity: (0,prop_types.oneOf)([
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ]),
    isGradient: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Line_Line = (Line);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js



/***/ }),

/***/ 361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2349);
/* harmony import */ var _insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const PageNavbarItem = (param)=>/*#__PURE__*/ {
    let { spacing ={
        ..._insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingProps */ .tF
    } , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_insightfulscience_atomic_react_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("page-navbar-item", ...(0,_insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingClassName */ .RB)(spacing)),
        children: children
    });
};
PageNavbarItem.propTypes = {
    spacing: _insightfulscience_atomic_react_props_spacing__WEBPACK_IMPORTED_MODULE_2__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (PageNavbarItem);


/***/ }),

/***/ 24661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67924);






const PageNavbarLink = (param)=>/*#__PURE__*/ {
    let { Tag =_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , iconName , rotateIcon =false , children , className ="" , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)("page-navbar-link", className),
        ...props,
        children: [
            iconName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                name: iconName,
                className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_4__/* .classes */ .S)(rotateIcon && "rotated-45")
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            })
        ]
    });
};
PageNavbarLink.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_5__.oneOf)([
            "a",
            "span",
            "button"
        ]),
        prop_types__WEBPACK_IMPORTED_MODULE_5__.elementType
    ]),
    iconName: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    rotateIcon: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_5__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (PageNavbarLink);


/***/ }),

/***/ 34246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageNavbar_PageNavbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js + 1 modules
var Line = __webpack_require__(15945);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/PageNavbar.js










const PageNavbar = (param)=>/*#__PURE__*/ {
    let { bgColor ="6" , alignHorizontal ="center" , withBorder =false , sticky =false , isFluid =false , fullWidthBorder =false , children , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    }  } = param;
    return (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            bgColor,
            ...fullWidthBorder ? {
                lg: {
                    border: {
                        bottom: {
                            width: 1,
                            color: "black--15"
                        }
                    }
                }
            } : {}
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), sticky && "page-navbar--sticky"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Container */.W2, {
            isFluid: isFluid,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,classes/* classes */.S)("page-navbar", "align-horizontal--".concat(alignHorizontal)),
                            children: children
                        })
                    })
                }),
                withBorder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Line/* default */.Z, {}) : null
            ]
        })
    });
};
PageNavbar.propTypes = {
    alignHorizontal: (0,prop_types.oneOf)([
        "start",
        "end",
        "center",
        "between",
        "around"
    ]),
    children: prop_types.node,
    isFluid: prop_types.bool,
    sticky: prop_types.bool,
    fullWidthBorder: prop_types.bool,
    bgColor: prop_types.string,
    withBorder: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var PageNavbar_PageNavbar = (PageNavbar);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/PageNavbar/index.js



/***/ }),

/***/ 20856:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Picture_Picture; },
  "Y": function() { return /* reexport */ sourceItemPropTypes; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/AssetsProvider/index.js + 1 modules
var AssetsProvider = __webpack_require__(84154);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Picture/Picture.js
/* eslint-disable prettier/prettier */ /* eslint-disable react/no-array-index-key */ 





const sourceItemPropTypes = {
    src1x: prop_types.string.isRequired,
    src2x: prop_types.string,
    minWidth: prop_types.number,
    maxWidth: prop_types.number
};
const SourceItem = (param)=>{
    let { baseUrl ="" , src1x , src2x , minWidth , maxWidth , ...props } = param;
    const media = (0,react.useMemo)(()=>{
        if (minWidth && maxWidth) {
            return "(min-width: ".concat(minWidth, "px) and (max-width: ").concat(maxWidth, "px)");
        }
        if (minWidth && !maxWidth) {
            return "(min-width: ".concat(minWidth, "px)");
        }
        if (!minWidth && maxWidth) {
            return "(max-width: ".concat(maxWidth, "px)");
        }
        return "";
    }, [
        minWidth,
        maxWidth
    ]);
    const srcSet = (0,react.useMemo)(()=>{
        if (src1x && src2x) {
            return "".concat(baseUrl).concat(src1x, " 1x, ").concat(baseUrl).concat(src2x, " 2x");
        }
        if (src1x && !src2x) {
            return "".concat(baseUrl).concat(src1x);
        }
        if (!src1x && src2x) {
            return "".concat(baseUrl).concat(src2x);
        }
        return "";
    }, [
        src1x,
        src2x
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
        media: "".concat(media),
        srcSet: "".concat(srcSet),
        ...props
    });
};
SourceItem.propTypes = {
    baseUrl: prop_types.string,
    ...sourceItemPropTypes
};
const Picture = (param)=>{
    let { loading ="lazy" , decoding ="async" , isBaseUrl =true , className ="" , src , alt ="" , srcList =[] , children =null , ...props } = param;
    const ctxBaseUrl = (0,react.useContext)(AssetsProvider/* default.context */.Z.context);
    const baseUrl = isBaseUrl ? ctxBaseUrl : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        className: (0,classes/* classes */.S)("picture", className),
        children: [
            srcList.length ? srcList.map((srcItem, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SourceItem, {
                    baseUrl: baseUrl,
                    ...srcItem
                }, "".concat(srcItem.src1x, "_").concat(index))) : null,
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                isBaseUrl: isBaseUrl,
                src: src,
                alt: alt,
                loading: loading,
                decoding: decoding,
                ...props
            })
        ]
    });
};
Picture.propTypes = {
    loading: prop_types.string,
    decoding: prop_types.string,
    isBaseUrl: prop_types.bool,
    className: prop_types.string,
    src: prop_types.string.isRequired,
    alt: prop_types.string,
    srcList: (0,prop_types.arrayOf)((0,prop_types.shape)(sourceItemPropTypes)),
    children: prop_types.node
};
/* harmony default export */ var Picture_Picture = (Picture);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Picture/index.js



/***/ }),

/***/ 19334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SectionTryForFree_SectionTryForFree; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/SectionTryForFree.js





const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__title",
        children: children
    });
};
Title.propTypes = {
    children: prop_types.node.isRequired
};
const Action = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "section-try-for-free__action",
        children: children
    });
};
Action.propTypes = {
    children: prop_types.node.isRequired
};
const SectionTryForFree = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: "section-try-for-free",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    utility: {
                        position: {
                            position: "relative",
                            zIndex: 1
                        }
                    },
                    children: children
                })
            })
        })
    });
};
SectionTryForFree.propTypes = {
    children: prop_types.node.isRequired
};
SectionTryForFree.Title = Title;
SectionTryForFree.Action = Action;
/* harmony default export */ var SectionTryForFree_SectionTryForFree = (SectionTryForFree);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SectionTryForFree/index.js



/***/ }),

/***/ 62039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "YT": function() { return /* reexport */ CardBlockCol; },
  "nC": function() { return /* reexport */ CardBlockRow; },
  "ZP": function() { return /* reexport */ CardBlock_CardBlock; }
});

// UNUSED EXPORTS: CardBlockAction, CardBlockSection

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/CardBlock/Grid.js




const CardBlockRow = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
        mx: true,
        my: true,
        spacing: {
            mt: 2
        },
        ...props,
        children: children
    });
};
CardBlockRow.propTypes = {
    children: prop_types.node.isRequired
};
const CardBlockCol = (param)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
        md: 6,
        lg: 3,
        spacing: {
            sm: {
                mb: 8
            },
            md: {
                mb: 4
            }
        },
        ...props,
        children: children
    });
};
CardBlockCol.propTypes = {
    children: prop_types.node.isRequired
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/LandingElement/SimpleSection.js
var SimpleSection = __webpack_require__(72989);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/CardBlock/Section.js




const CardBlockSection = (param)=>/*#__PURE__*/ {
    let { id ="" , title ="" , children =null , isBorderNone =true , ...props } = param;
    return (0,jsx_runtime.jsxs)(SimpleSection/* default */.Z, {
        id: id,
        isBorderNone: isBorderNone,
        ...props,
        children: [
            title ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleSection/* default.Title */.Z.Title, {
                children: title
            }) : null,
            children
        ]
    });
};
CardBlockSection.propTypes = {
    isBorderNone: prop_types.bool,
    id: prop_types.string,
    title: prop_types.string,
    children: prop_types.node
};
/* harmony default export */ var Section = ((/* unused pure expression or super */ null && (CardBlockSection)));

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/CardBlock/Action.js





const CardBlockAction = (param)=>/*#__PURE__*/ {
    let { ActionComponent =Button/* default */.Z , children , ...props } = param;
    return (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
        sx: {
            textAlign: "center"
        },
        spacing: {
            mt: 20
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionComponent.Link, {
            styleType: "primary",
            isOutline: true,
            size: "xs",
            ...props,
            children: children
        })
    });
};
CardBlockAction.propTypes = {
    ActionComponent: prop_types.elementType,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Action = ((/* unused pure expression or super */ null && (CardBlockAction)));

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/AssetsProvider/index.js + 1 modules
var AssetsProvider = __webpack_require__(84154);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Image/index.js + 1 modules
var Image = __webpack_require__(10334);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Picture/index.js + 1 modules
var Picture = __webpack_require__(20856);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sizing.js
var sizing = __webpack_require__(88270);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/CardBlock/CardBlock.js













const CardBlock = (param)=>{
    let { LinkComponent =Link/* default */.Z , className ="" , imgClassName ="" , imgSpacing ={
        ...props_spacing/* spacingProps */.tF
    } , imgWrapperUtility ={
        ...props_utility/* utilityProps */.Gm
    } , imgWrapperSizing ={
        ...sizing/* sizingProps */.H6
    } , imgWrapperSpacing ={
        ...props_spacing/* spacingProps */.tF
    } , imgWrapperClassName , imgSrc ="" , imgSrcList =[] , href , isImgFluid =false , titleText , descriptionText ="" , cardType ="" , linkButtonText , isBaseUrl =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , linkMt ="auto" , children =null  } = param;
    const ctxBaseUrl = (0,react.useContext)(AssetsProvider/* default.context */.Z.context);
    const baseUrl = isBaseUrl ? ctxBaseUrl : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classes/* classes */.S)("card-block", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComponent, {
                href: href,
                isBaseClassName: false,
                className: "card-block__title-link",
                children: [
                    imgSrc && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: (0,classes/* classes */.S)("card-block__image-section", isImgFluid && "card-block__image-section--fluid", ...(0,props_utility/* utilityClassName */.b2)(imgWrapperUtility), ...(0,sizing/* sizingClassName */.rs)(imgWrapperSizing), ...(0,props_spacing/* spacingClassName */.RB)(imgWrapperSpacing), imgWrapperClassName),
                        children: [
                            imgSrcList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Picture/* default */.Z, {
                                src: imgSrc,
                                srcList: imgSrcList,
                                className: (0,classes/* classes */.S)("card-block__image", isImgFluid && "card-block__image--fluid", ...(0,props_spacing/* spacingClassName */.RB)(imgSpacing), imgClassName),
                                isBaseUrl: false
                            }) : null,
                            imgSrc && !imgSrcList.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "".concat(baseUrl).concat(imgSrc),
                                className: (0,classes/* classes */.S)("card-block__image", isImgFluid && "card-block__image--fluid", ...(0,props_spacing/* spacingClassName */.RB)(imgSpacing), imgClassName),
                                isBaseUrl: false
                            }) : null,
                            children
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "card-block__link-section",
                        children: [
                            cardType && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "card-block__type",
                                children: cardType
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "card-block__title",
                                children: titleText
                            })
                        ]
                    })
                ]
            }),
            (descriptionText || linkButtonText) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "card-block__content-section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                        utility: {
                            display: "block"
                        },
                        sx: {
                            fontColor: "black--64"
                        },
                        spacing: {
                            mb: 2
                        },
                        children: descriptionText
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
                        spacing: {
                            mt: linkMt
                        },
                        children: linkButtonText && /*#__PURE__*/ (0,jsx_runtime.jsxs)(LinkComponent, {
                            href: href,
                            sx: {
                                fontSize: "m"
                            },
                            children: [
                                linkButtonText,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "angle-right"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
CardBlock.propTypes = {
    LinkComponent: prop_types.elementType,
    className: prop_types.string,
    imgSpacing: props_spacing/* spacingPropTypes */.Xj,
    imgClassName: prop_types.string,
    imgWrapperClassName: prop_types.string,
    imgWrapperUtility: props_utility/* utilityPropTypes */.pQ,
    imgWrapperSizing: sizing/* sizingPropTypes */.bm,
    imgWrapperSpacing: props_spacing/* spacingPropTypes */.Xj,
    imgSrc: prop_types.string,
    imgSrcList: (0,prop_types.arrayOf)((0,prop_types.shape)(Picture/* sourceItemPropTypes */.Y)),
    isImgFluid: prop_types.bool,
    cardType: prop_types.string,
    href: prop_types.string.isRequired,
    titleText: prop_types.string.isRequired,
    descriptionText: prop_types.string,
    linkButtonText: prop_types.string,
    isBaseUrl: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    linkMt: (0,prop_types.oneOf)([
        prop_types.string,
        prop_types.number
    ]),
    children: prop_types.node
};
/* harmony default export */ var CardBlock_CardBlock = (CardBlock);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/CardBlock/index.js


;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/r2/CardBlock/index.js
// TODO: import to this file is deprecated!







/***/ }),

/***/ 65863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5098);
/* harmony import */ var _insightfulscience_atomic_react_r2_CardBlock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62039);
/* harmony import */ var _insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8610);
/* harmony import */ var _utils_getContentProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76638);
/* harmony import */ var _utils_url_preparePostLink__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71306);
/* harmony import */ var _ui_RichTextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10257);
/* eslint-disable react/no-array-index-key */ 








const FeaturedContectItems = (param)=>{
    let { items =[] , isImgFluid =false , ...props } = param;
    const [t] = (0,_insightfulscience_smart_react_i18__WEBPACK_IMPORTED_MODULE_4__/* .useLocale */ .bU)("blog");
    return items.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_CardBlock__WEBPACK_IMPORTED_MODULE_3__/* .CardBlockRow */ .nC, {
        children: items.map((item, index)=>{
            const { slug ="" , externalUrl =""  } = item;
            const description = item.teaser || item.lead || item.description;
            const contentProps = (0,_utils_getContentProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(item.sys_type, item.type);
            const DefaultLinkComponent = contentProps && contentProps.alias ? _insightfulscience_smart_react_NextLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z : _ui_RichTextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
            const LinkComponent = (0,_utils_url_preparePostLink__WEBPACK_IMPORTED_MODULE_7__/* .hasHtmEnding */ .T)(slug) ? _ui_RichTextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z : DefaultLinkComponent;
            switch(item.sys_type){
                case "pageBlog":
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_CardBlock__WEBPACK_IMPORTED_MODULE_3__/* .CardBlockCol */ .YT, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_CardBlock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            titleText: item.title,
                            href: contentProps && contentProps.alias ? "".concat(contentProps.alias, "/").concat(slug) : "#",
                            isImgFluid: true,
                            imgSrc: item.thumbnail,
                            descriptionText: item.lead,
                            linkButtonText: t("READ_MORE"),
                            cardType: item.articleType,
                            utility: {
                                bgColor: "white"
                            }
                        })
                    }, "".concat(item.sys_id, "_").concat(index));
                default:
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_CardBlock__WEBPACK_IMPORTED_MODULE_3__/* .CardBlockCol */ .YT, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_r2_CardBlock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            isImgFluid: isImgFluid,
                            LinkComponent: LinkComponent,
                            cardType: (contentProps === null || contentProps === void 0 ? void 0 : contentProps.typePlaceholder) || item.type || "",
                            titleText: item.title,
                            imgSrc: item.image,
                            descriptionText: description,
                            href: contentProps && contentProps.alias ? "".concat(contentProps.alias, "/").concat(slug) : externalUrl,
                            linkButtonText: (contentProps === null || contentProps === void 0 ? void 0 : contentProps.linkPlaceholder) || "",
                            ...props
                        })
                    }, "".concat(item.sys_id, "_").concat(index));
            }
        })
    }) : null;
};
FeaturedContectItems.propTypes = {
    items: (0,prop_types__WEBPACK_IMPORTED_MODULE_8__.arrayOf)((0,prop_types__WEBPACK_IMPORTED_MODULE_8__.shape)({
        sys_type: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        slug: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        externalUrl: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        teaser: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        description: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        title: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        image: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        type: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        lead: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        articleType: prop_types__WEBPACK_IMPORTED_MODULE_8__.string,
        thumbnail: prop_types__WEBPACK_IMPORTED_MODULE_8__.string
    })),
    isImgFluid: prop_types__WEBPACK_IMPORTED_MODULE_8__.bool,
    imgClassName: prop_types__WEBPACK_IMPORTED_MODULE_8__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (FeaturedContectItems);


/***/ }),

/***/ 4830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ mapItems; }
/* harmony export */ });
const getTitle = (item)=>{
    switch(item.sys.contentType.sys.id){
        case "atomLink":
            var ref;
            return (ref = item.fields) === null || ref === void 0 ? void 0 : ref.linkText;
        default:
            var ref1;
            return (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.title;
    }
};
const getDescription = (item)=>{
    switch(item.sys.contentType.sys.id){
        case "pageWebinar":
            var ref;
            return (ref = item.fields) === null || ref === void 0 ? void 0 : ref.lead;
        case "pageIntegration":
            var ref1;
            return (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.subtitle;
        case "atomLink":
            var ref2;
            return (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : ref2.description;
        default:
            var ref3;
            return (ref3 = item.fields) === null || ref3 === void 0 ? void 0 : ref3.metaDescription;
    }
};
const getImage = (item)=>{
    switch(item.sys.contentType.sys.id){
        case "pageIntegration":
            var ref, ref1, ref2, ref3;
            return (ref = item.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.logo) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : ref3.url;
        default:
            var ref4, ref5, ref6, ref7;
            return (ref4 = item.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.thumbnail) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : ref7.url;
    }
};
const getType = (item)=>{
    switch(item.sys.contentType.sys.id){
        case "pageWebinar":
            var ref;
            return (ref = item.fields) === null || ref === void 0 ? void 0 : ref.eventType;
        case "pageIntegration":
            var ref1;
            return (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.integrationTag;
        case "atomLink":
            var ref2;
            return (ref2 = item.fields) === null || ref2 === void 0 ? void 0 : ref2.linkTag;
        default:
            return "";
    }
};
const getExternalUrl = (item)=>{
    switch(item.sys.contentType.sys.id){
        case "atomLink":
            var ref;
            return (ref = item.fields) === null || ref === void 0 ? void 0 : ref.linkUrl;
        default:
            var ref1;
            return (ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.externalUrl;
    }
};
const mapItems = (items)=>{
    return items.map((item)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        return {
            sys_id: item.sys.id,
            sys_type: item.sys.contentType.sys.id,
            title: getTitle(item),
            description: getDescription(item),
            teaser: ((ref = item.fields) === null || ref === void 0 ? void 0 : ref.teaser) || "",
            image: getImage(item),
            slug: ((ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.slug) || "",
            url: ((ref2 = item.fields) === null || ref2 === void 0 ? void 0 : ref2.linkUrl) || "",
            externalUrl: getExternalUrl(item) || "",
            type: getType(item),
            lead: ((ref3 = item.fields) === null || ref3 === void 0 ? void 0 : ref3.lead) || ((ref4 = item.fields) === null || ref4 === void 0 ? void 0 : ref4.leadIn) || "",
            thumbnail: (ref5 = item.fields) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.thumbnail) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.file) === null || ref8 === void 0 ? void 0 : ref8.url,
            articleType: (ref9 = item.fields) === null || ref9 === void 0 ? void 0 : ref9.articleType
        };
    });
};
const mapFeaturedBlock = (data)=>{
    const { items  } = data;
    return items.map((item)=>{
        return {
            sys_id: item.sys.id,
            sys_type: item.sys.contentType.sys.id,
            id: item.fields.id,
            name: item.fields.name,
            blockOrder: item.fields.blockOrder,
            items: mapItems(item.fields.contentReference)
        };
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (mapFeaturedBlock);


/***/ })

}]);